import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Chart, ChartOptions } from "chart.js";
@Injectable()
export class ChartService {
  private opacity: number = 0.5;

  constructor() {}

  public getPaymentSummaryChartConfig() {
    const footer = (tooltipItems) => {
      let sum = 0;

      tooltipItems.forEach((tooltipItem) => {
        sum += tooltipItem.parsed.y;
      });
      return "Sum: " + sum;
    };
    const paymentSummeryChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        labels: {
          generateLabels(chart) {
            const originalLabels =
              Chart.defaults.pie.legend.labels.generateLabels(chart);
            const data = chart.data;
            const total = data.datasets[0].data.reduce(
              (sum, value) => sum + value,
              0
            );

            originalLabels.forEach((label, i) => {
              const value = data.datasets[0].data[i];
              const valueWithoutDecimals = Math.floor(
                value || 0
              ).toLocaleString("en-US", { maximumFractionDigits: 0 });

              label.text = `${data.labels[i]} (${valueWithoutDecimals} ₪)`;
            });

            return originalLabels;
          },
          fontcolor: "#000000",
          fontSize: 20, // Change this value to adjust font size
        },
      },
      tooltip: {
        backgroundColor: "rgba(255,255,0,0.5)",
      },

      plugins: {
        tooltip: {
          callbacks: {
            footer,
          },
        },
        datalabels: {
          color: "#fff",
          fontSize: 28,
          font: {
            weight: "bold",
            size: 28,
          },

          display: true,
          align: "center",
          anchor: "center",
        },
      },
    };
    const paymentSummeryChartColors = [
      {
        backgroundColor: [
          `rgba(0,255,0,${this.opacity})`, // normal - green
          `rgba(255,128,0,${this.opacity})`, // meshutaf - orange
          `rgba(255,0,0,${this.opacity})`, // open check - red
          `rgba(255,0,0,${this.opacity})`, // unhandled returns - red
          `rgba(0,0,255,${this.opacity})`, // handled returns - blue
        ],
        borderColor: "#4b4b4b", // This will make all segment borders white
        borderWidth: 1, // Optional: controls the width of the bor
      },
    ];
    return {
      paymentSummeryChartOptions,
      paymentSummeryChartColors,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/chart.service.ts